var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{'no-nav': _vm.hideMainNav},attrs:{"id":"root-app"}},[_c('sidebar',{attrs:{"current-app":_vm.highlightedSidebarApp}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }